import type { CookedProduct } from '@apps/registry/common/selectors/ProductListSelector';
import { useEventInfo } from '@shared/utils/eventInfo';

export const usePrepareAdminSHopUrl = (product: CookedProduct | null) => {
  const { eventHandle } = useEventInfo();
  const pattern = /shop\/item\/(.+)/;
  const matches = product?.pdpUrl.match(pattern);
  const catalogId = matches?.length && matches[1] ? matches[1] : undefined;
  if (catalogId) {
    return `/${eventHandle}/edit/registry/shop/item/${catalogId}`;
  }
  return product?.pdpUrl;
};
